<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-06 11:25:18
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-11-01 20:33:54
-->
<template>
  <div
    class="map-right-info"
    :class="showRightInfo ? 'map-right-info-show' : 'map-right-info-close'"
    :style="{ height: hasMapBottomInfo ? '' : '100%' }"
  >
    <div class="map-right-info-content">
      <!-- 派活信息 -->
      <div class="assign-detail" v-show="showAssignDetail">
        <div class="plate plate-info" v-if="assignDetail">
          <div class="title">派活信息</div>
          <ul class="list">
            <li class="item">
              <p>派活时间：{{ assignDetail.uptTime }}</p>
              <p>
                派活地块：{{ assignDetail.landNum }}块/{{
                  assignDetail.landArea
                }}亩
              </p>
              <p>
                时间要求：{{ assignDetail.assignTimeBeginString }}~{{
                  assignDetail.assignTimeEndString
                }}
              </p>
            </li>
          </ul>
        </div>
        <div class="plate plate-machine" v-if="assignDetail">
          <div class="title">
            <i class="iconfont icon-nongjiguanli"></i>派活机具
          </div>
          <ul
            class="list"
            v-if="
              assignDetail.assingMachineInfoDtoList &&
              assignDetail.assingMachineInfoDtoList.length > 0
            "
          >
            <li
              class="item"
              v-for="item in assignDetail.assingMachineInfoDtoList"
              :key="item.machineId"
            >
              <div class="left-side">
                <img :src="item.machineUrl" alt="" />
              </div>
              <div class="right-side">
                <p>{{ item.machineName }}</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="plate plate-person" v-if="assignDetail">
          <div class="title">
            <i class="iconfont icon-paihuorenyuan"></i>派活人员
          </div>
          <ul
            class="list"
            v-if="
              assignDetail.accountNames && assignDetail.accountNames.length > 0
            "
          >
            <li
              class="item"
              v-for="item in assignDetail.accountNames"
              :key="item.employeeId"
            >
              <img :src="item.employeePhotoUrl" alt="" />
              <p>{{ item.employeeName }}/机手</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 地块、作业、审核 -->
      <div class="land-detail" v-show="showLandDetail">
        <el-tabs v-model="activeName">
          <el-tab-pane
            v-if="mapRightInfoOptions.hasLandInfoForLandDetail"
            label="地块信息"
            name="first"
          >
            <div
              class="land-info"
              v-if="landInfo && mapRightInfoOptions.landInfoType == 'vertical'"
            >
              <ul class="list">
                <li class="item">
                  <div class="left-side">
                    <i class="iconfont icon-tudiquanshu1"></i>
                  </div>
                  <div class="right-side">
                    <p class="tit">土地权属</p>
                    <p class="name">
                      {{ landInfo.croplandVillGroupName }}
                    </p>
                  </div>
                </li>
                <li class="item">
                  <div class="left-side">
                    <i class="iconfont icon-a-1dikuaiweizhi"></i>
                  </div>
                  <div class="right-side">
                    <p class="tit">地块位置</p>
                    <p class="name">{{ landInfo.address }}</p>
                  </div>
                </li>
                <li class="item">
                  <div class="left-side">
                    <i class="iconfont icon-jingyingquanguishu"></i>
                  </div>
                  <div class="right-side">
                    <p class="tit">经营权归属</p>
                    <p class="name">
                      {{ landInfo.croplandFranchisedTypeName }}
                    </p>
                  </div>
                </li>
                <li class="item">
                  <div class="left-side">
                    <i class="iconfont icon-dikuaisuoshu"></i>
                  </div>
                  <div class="right-side">
                    <p class="tit">经营主体</p>
                    <p class="name">
                      {{ landInfo.croplandProprietor }}
                    </p>
                  </div>
                </li>
                <li class="item">
                  <div class="cell">
                    <div class="left-side">
                      <i class="iconfont icon-dikuaibianhao"></i>
                    </div>
                    <div class="right-side">
                      <p class="tit">地块编号</p>
                      <p class="name">{{ landInfo.croplandId }}</p>
                    </div>
                  </div>
                  <div class="cell">
                    <div class="left-side">
                      <i class="iconfont icon-tudishuxing"></i>
                    </div>
                    <div class="right-side">
                      <p class="tit">土地属性</p>
                      <p class="name">{{ landInfo.croplandTypeName }}</p>
                    </div>
                  </div>
                </li>
                <li class="item">
                  <div class="cell">
                    <div class="left-side">
                      <i class="iconfont icon-dikuaizhouchang"></i>
                    </div>
                    <div class="right-side">
                      <p class="tit">地块周长</p>
                      <p class="name">{{ landInfo.croplandPerimeter }}米</p>
                    </div>
                  </div>
                  <div class="cell">
                    <div class="left-side">
                      <i class="iconfont icon-dikuaimianji"></i>
                    </div>
                    <div class="right-side">
                      <p class="tit">地块面积</p>
                      <p class="name">{{ landInfo.croplandArea }}亩</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <slot name="landInfo" :landInfo="landInfo"></slot>
          </el-tab-pane>
          <el-tab-pane
            v-if="mapRightInfoOptions.hasWorkInfoForLandDetail"
            label="作业信息"
            name="second"
          >
            <div class="work-info" v-if="workInfo">
              <p class="type">作业类型：{{ workInfo.workTypeName }}</p>
              <div class="info">
                <div class="cell">
                  <p class="tit">
                    <span class="large">{{ workInfo.trueWorkArea || 0 }}</span
                    >亩
                  </p>
                  <p class="name">已作业</p>
                </div>
                <div class="cell">
                  <p class="tit">
                    <span class="large">{{ workInfo.completeRate || 0 }}</span
                    >%
                  </p>
                  <p class="name">完成率</p>
                </div>
              </div>
              <ul
                class="list"
                v-if="
                  workInfo.machinePersonWorks &&
                  workInfo.machinePersonWorks.length > 0
                "
              >
                <li
                  class="item"
                  v-for="(item, index) in workInfo.machinePersonWorks"
                  :key="index"
                >
                  <p>机手：{{ item.driverName }}</p>
                  <p>作业机具：{{ item.machineName }}</p>
                  <p>出厂编号：{{ item.machineryCode }}</p>
                  <p>北斗终端类型：{{ item.iotTypeName }}</p>
                  <p>北斗终端编号：{{ item.imei }}</p>
                  <p>作业面积：{{ item.workArea }}亩</p>
                </li>
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="mapRightInfoOptions.hasAuditInfoForLandDetail"
            label="审核信息"
            name="third"
          >
            <div class="audit-info" v-if="auditInfo">
              <div v-for="(item, index) in auditInfo" :key="index">
                <ul class="list">
                  <li class="item">
                    <p>审核时间：</p>
                    <p>审核员：</p>
                    <p>审核结果：</p>
                    <p>备注：</p>
                  </li>
                </ul>
                <div
                  class="demo-image__preview"
                  v-if="item.srcList && item.srcList.length > 0"
                >
                  <div v-for="(val, i) in item.srcList" :key="i">
                    <el-image
                      v-if="i < 3"
                      style="width: 82px; height: 82px"
                      :src="item.srcList[i]"
                      :preview-src-list="item.srcList"
                    >
                    </el-image>

                    <div
                      class="img-mask"
                      v-if="item.srcList.length > 3 && i == 2"
                      @click="handlePreviewImg(item.srcList)"
                    >
                      查看更多
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 轨迹-作业信息、轨迹-轨迹地块信息 -->
      <div class="trajectory-detail" v-show="showTrajectoryDetail">
        <el-tabs v-model="activeNameT">
          <el-tab-pane label="作业信息" name="first">
            <div class="work-info" v-if="trajectoryInfo">
              <ul class="list">
                <li class="item">作业机手：{{ trajectoryInfo.driverName }}</li>
                <li class="item">
                  作业机具：{{ trajectoryInfo.machineryName }}
                </li>
                <li class="item">
                  出厂编号：{{ trajectoryInfo.machineryCode }}
                </li>
                <li class="item">北斗终端编号：{{ trajectoryInfo.imei }}</li>
                <li class="item">作业时间：{{ trajectoryInfo.sendDate }}</li>
                <li class="item">作业面积：{{ trajectoryInfo.blockArea }}</li>
                <li class="item" v-if="trajectoryInfo.workTypeName">
                  作业类型：{{ trajectoryInfo.workTypeName }}
                </li>
              </ul>
              <div
                v-if="mapRightInfoOptions.hasTrajectoryPlayBtn"
                class="btn-foot"
                @click="handleTrajectoryPlay(trajectoryInfo.workId)"
              >
                <el-button type="primary" round
                  ><i class="iconfont icon-guijihuifang"></i>轨迹回放</el-button
                >
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="轨迹地块" name="second">
            <div class="trajectory-info" v-if="trajectoryBlockInfo">
              <ul
                class="list"
                v-for="(item, index) in trajectoryBlockInfo"
                :key="index"
              >
                <li class="item">土地权属：{{ item.croplandVillGroupName }}</li>
                <li class="item">地块编号：{{ item.croplandId }}</li>
                <li class="item">地块面积：{{ item.croplandArea }}亩</li>
                <li class="item">经营主体：{{ item.croplandProprietor }}</li>
                <li class="item">作业面积：{{ item.blockArea }}亩</li>
              </ul>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 打卡-打卡记录 -->
      <ClockInDetail
        v-if="showAssignClockInDetail"
        :curMarkerVal="curMarkerVal"
      ></ClockInDetail>
      <div class="close-btn" @click="handleChangeRightInfo">
        <i class="el-icon-d-arrow-right"></i>
      </div>
    </div>
    <el-image
      ref="previewImg"
      style="width: 0; height: 0"
      :src="previewSrcList[0]"
      :preview-src-list="previewSrcList"
    >
    </el-image>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ClockInDetail from "./ClockInDetail.vue";
export default {
  components: {
    ClockInDetail,
  },
  data() {
    return {
      activeName: "first",
      activeNameT: "first",
      activeNameC: "first",
      landInfo: {}, // 地块切卡的地块信息（地图右侧信息）
      workInfo: {}, // 地块切卡的作业信息（地图右侧信息）
      auditInfo: [], // 地块切卡的审核信息（地图右侧信息）
      previewSrc: "",
      previewSrcList: [],
      trajectoryInfo: {}, //轨迹的信息（地图右侧信息）
      trajectoryBlockInfo: [], //轨迹的地块信息（地图右侧信息）
      assignDetail: {}, // 派活信息（地图右侧信息）
    };
  },
  props: {
    // 是否显示右侧信息
    showRightInfo: {
      type: Boolean,
    },
    // 是否显示地块的信息
    showLandDetail: {
      type: Boolean,
    },
    // 是否显示轨迹的信息
    showTrajectoryDetail: {
      type: Boolean,
    },
    // 是否显示派活的信息
    showAssignDetail: {
      type: Boolean,
    },
    // 是否显示打卡的信息
    showAssignClockInDetail: {
      type: Boolean,
    },
    // 点击某块的数据
    curPolygonVal: {
      type: Object,
    },
    // 点击某marker的数据
    curMarkerVal: {
      type: Object,
    },
    hasMapBottomInfo: {
      type: Boolean,
    },
    // 右侧信息配置项
    mapRightInfoOptions: {
      type: Object,
      default: function () {
        return {
          landInfoType: "vertical", //地块信息样式：vertical 纵向即一行一列，Horizontal横向即一行多列
          hasLandInfoForLandDetail: true, // 地块信息面板是否有地块信息切卡
          hasWorkInfoForLandDetail: true, // 地块信息面板是否有作业信息切卡
          hasAuditInfoForLandDetail: true, // 地块信息面板是否有审核信息切卡
          hasTrajectoryPlayBtn: true, // 是否有轨迹回放按钮
        };
      },
    },
  },
  watch: {
    curPolygonVal(n) {
      if (this.showLandDetail) {
        this.landInfo = {};
        this.workInfo = {};
        let { landId, workLandId } = n;
        this.$http.work.getLandDetail({ id: landId }).then((res) => {
          this.landInfo = res.data;
        });
        if (workLandId) {
          this.$http.work.getWorkLandDetails({ workLandId }).then((res) => {
            this.workInfo = res.data;
          });
        }
      }
      if (this.showTrajectoryDetail) {
        let { id } = n;
        this.$http.work.getLandTrajectoryInfo({ workId: id }).then((res) => {
          this.trajectoryInfo = res.data;
          this.trajectoryInfo.workId = id;
        });
        this.$http.work
          .getTrajectoryLandInfo({ trajectoryId: id })
          .then((res) => {
            this.trajectoryBlockInfo = res.data;
          });
      }
    },
  },
  created() {
    this.$bus.$on("getAssignDetail", this.getAssignDetail);
  },
  destroyed() {
    this.$bus.$off("getAssignDetail");
  },
  methods: {
    ...mapActions("map", ["changeTrajectoryPlay"]),

    /**
     * @descripttion: 触发父组件切换展示地图右侧信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:37
     * @param {*}
     * @return {*}
     */
    handleChangeRightInfo() {
      this.$bus.$emit("changeRightInfo", { show: false });
    },
    /**
     * @descripttion: 获取派活信息（地图右侧信息）
     * @Author: juanjuanhui
     * @Date: 2021-12-02 19:57:06
     * @param {*}
     */
    getAssignDetail(params) {
      this.$http.work.getAssignDetails(params).then((res) => {
        this.assignDetail = res.data;
      });
    },
    /**
     * @descripttion: 轨迹播放
     * @Author: juanjuanhui
     * @Date: 2021-12-13 11:47:27
     * @param {*} workId
     */
    handleTrajectoryPlay(workId) {
      this.changeTrajectoryPlay({ show: true, workId });
    },
    /**
     * @descripttion: 预览图片
     * @Author: juanjuanhui
     * @Date: 2021-12-16 18:55:09
     */
    handlePreviewImg(data) {
      this.previewSrcList = data;
      this.$refs.previewImg.showViewer = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.map-right-info {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: calc(100% - 160px);
  background-color: rgba($color: #000000, $alpha: 0.75);
  transition: 0.3s;
  &.map-right-info-show {
    transform: translateX(0);
  }
  &.map-right-info-close {
    transform: translateX(120%);
  }
  .close-btn {
    position: absolute;
    top: 50%;
    left: -32px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 72px;
    cursor: pointer;
    background-color: rgba($color: #000000, $alpha: 0.75);
    .el-icon-d-arrow-right {
      color: #fff;
    }
  }
  .map-right-info-content {
    // width: 100%;
    height: 100%;
    padding: 15px;
    box-sizing: border-box;
    overflow-y: auto;
    /*滚动条样式*/
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(255, 255, 255, 0.2);
    }
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(255, 255, 255, 0.1);
    }
  }
  .assign-detail {
    .plate {
      padding: 0 0 15px;
      font-size: 14px;
      line-height: 26px;
      color: #d0e7e8;
      &:not(:last-child) {
        border-bottom: 1px solid #3d403b;
      }
      &.plate-info {
        .title {
          display: inline-flex;
          align-items: center;
          height: 36px;
          padding: 0 18px;
          margin-bottom: 10px;
          color: #ffffff;
          background-color: #018388;
          border-radius: 0px 10px 0px 10px;
        }
      }
      &.plate-machine {
        .title {
          padding: 10px 0;
          color: #79dde1;
          .iconfont {
            margin-right: 5px;
          }
        }
        .list {
          .item {
            display: flex;
            align-items: center;
            .left-side {
              width: 60px;
              height: 45px;
              background-color: #ffffff;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .right-side {
              flex: 1;
              margin-left: 15px;
              p {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
      &.plate-person {
        .title {
          padding: 10px 0;
          color: #79dde1;
          .iconfont {
            margin-right: 5px;
          }
        }
        .list {
          display: flex;
          flex-wrap: wrap;
          .item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 33.333%;
            padding: 0 5px;
            box-sizing: border-box;
            img {
              width: 50px;
              height: 50px;
              border-radius: 100%;
            }
            p {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
  .land-detail {
    .land-info {
      .list {
        .item {
          display: flex;
          align-items: center;
          min-height: 70px;
          border-bottom: 1px solid #3d403b;
          // &:not(:last-child) {
          //   border-bottom: 1px solid #3d403b;
          // }
          .left-side {
            margin: 10px 20px;
            i {
              color: #2ac9cf;
              font-size: 36px;
            }
          }
          .right-side {
            flex: 1;
            margin: 10px 0;
            .tit {
              color: #2ac9cf;
            }
            .name {
              font-size: 18px;
              color: #d0e7e8;
            }
          }
          .cell {
            display: flex;
            align-items: center;
            width: 50%;
            min-height: 70px;
            &:first-child {
              border-right: 1px solid #3d403b;
            }
            .left-side {
              margin: 0 10px;
            }
          }
        }
      }
    }
    .work-info {
      color: #d0e7e8;
      font-size: 14px;
      .type {
        margin-top: 20px;
      }
      .info {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 20px 0 25px;
        .cell {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .tit {
            color: #ffe400;
            .large {
              font-size: 28px;
            }
          }
        }
      }
      .list {
        .item {
          padding: 15px 0;
          line-height: 26px;
          color: #d0e7e8;
          border-top: 1px solid #3d403b;
        }
      }
    }
    .audit-info {
      color: #d0e7e8;
      font-size: 14px;
      .list {
        .item {
          padding: 15px 0 0;
          line-height: 26px;
          color: #d0e7e8;
          border-top: 1px solid #3d403b;
        }
      }
      .demo-image__preview {
        display: flex;
        margin-top: 5px;
        & > div {
          position: relative;
          margin-right: 9px;
          .img-mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
          .el-image {
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
  .trajectory-detail {
    padding: 0 0 15px;
    ::v-deep .el-tabs__item {
      width: 50%;
    }
    .list {
      .item {
        font-size: 14px;
        line-height: 26px;
        color: #d0e7e8;
      }
    }
    .work-info {
      padding: 20px 0;
      border-bottom: 1px solid #3d403b;
      .btn-foot {
        text-align: center;
        .el-button {
          margin-top: 10px;
          font-size: 16px;
          .iconfont {
            margin-right: 5px;
          }
        }
      }
    }
    .trajectory-info {
      .list {
        padding: 20px 0;
        border-bottom: 1px solid #3d403b;
      }
    }
  }
  ::v-deep {
    .el-tabs__header {
      margin-bottom: 0;
      .el-tabs__nav {
        width: 100%;
        padding: 0 10px;
        margin-top: 0;
        box-sizing: border-box;
        .el-tabs__active-bar {
          height: 0;
        }
        .el-tabs__item {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0 9px;
          color: #fff;
          height: 36px;
          &:nth-child(2) {
            padding-left: 9px !important;
          }
          &:not(:last-child) {
            margin-right: 4px;
          }
          &::after {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: -1;
            background-color: #018388;
            transform: skew(-20deg);
          }
          &.is-active {
            color: #fff;
            font-weight: normal;
            &::after {
              background-color: #e29002;
            }
          }
        }
      }
    }
  }
}
</style>
